import React from 'react';
import PropTypes from 'prop-types';
import { isNil, get } from 'lodash';

import * as annotationOps from '../../../api/Annotations/annotation-operations';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';

import AnnotationPopover from '../../atoms/AnnotationPopover';

const AnnotationMarker = ({
  clickadivHeight,
  clickadivWidth,
  markerVisible,
  selectedAnnotation,
  showAnnotation
}) => {
  const { x, y, width, height } = annotationOps.getVideoPosition(selectedAnnotation);
  const popupName = templateOps.getName(annotationOps.getTemplate(selectedAnnotation));

  if (!isNil(get(selectedAnnotation, 'geoJSON.geometry'))) {
    return (
      <AnnotationPopover
        annotationContent={popupName}
        top={y * (clickadivHeight / height)}
        left={x * (clickadivWidth / width)}
        isVisible={markerVisible}
        annotationId={annotationOps.getId(selectedAnnotation)}
        openAnnotation={showAnnotation}
      />
    );
  }
  return '';
};

AnnotationMarker.defaultProps = {
  clickadivWidth: 0,
  clickadivHeight: 0
};

AnnotationMarker.propTypes = {
  clickadivHeight: PropTypes.number,
  clickadivWidth: PropTypes.number,
  markerVisible: PropTypes.bool.isRequired,
  selectedAnnotation: PropTypes.object.isRequired,
  showAnnotation: PropTypes.func.isRequired
};

export default AnnotationMarker;
